import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import "../styles/ContactForm.scss";

const ContactForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, // Access from .env
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // Access from .env
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY // Access from .env
      )
      .then(
        (result) => {
          console.log('Email sent successfully:', result.text);
          alert('Your message has been sent!');
        },
        (error) => {
          console.log('Error sending email:', error.text, process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
          alert('There was an error sending your message. Please try again.');
        }
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail} className="contact-form">
      <label htmlFor="name">Name</label>
      <input type="text" id="name" name="from_name" required />

      <label htmlFor="email">Email</label>
      <input type="email" id="email" name="from_email" required />

      <label htmlFor="message">Message</label>
      <textarea id="message" name="message" required />

      <button type="submit">Send</button>
    </form>
  );
};

export default ContactForm;
